export default "__VITE_ASSET__gn_hvcS1__"